module.exports = __webpack_public_path__ + "img/nz.3029953.svg";